import queryString from "querystring";
import "isomorphic-fetch";

const getUserFromLocalStorage = () => {
  let tokenExpiration = localStorage.getItem("USER_ACCESS_TOKEN_EXPIRATION");
  if (!tokenExpiration || Number(tokenExpiration) < Date.now()) return null;
  return { token: localStorage.getItem("USER_ACCESS_TOKEN") };
};

const updateStatus = (status, statusInfo) => {
  return {
    type: status,
    data: statusInfo,
  };
};

const parseUrlQuery = (query) => {
  if (query.indexOf("?") >= 0) query = query.substr(query.indexOf("?") + 1);
  return queryString.parse(query);
};

const resolveConfig = (config) => {
  let result = Object.assign({}, config);

  const user = getUserFromLocalStorage();

  result.headers = {
    ...result.headers,
    ...(user && user.token && { authorization: user.token }),
    "Content-Type": "application/json",
  };

  result.body = JSON.stringify(result.body);

  return result;
};

global.lastPost = Date.now();

const callApi = async (
  url,
  config,
  onRequestFinish,
  onRequestSuccess,
  onRequestFailure,
) => {
  let finalUrl = url;

  if (config.method === "post") {
    global.lastPost = Date.now() + Math.trunc(Math.random() * 1000);
  } else {
    finalUrl = `${url}${url.includes("?") ? "&" : "?"}decace=${global.lastPost
      }`;
  }

  try {
    const response = await fetch(finalUrl, resolveConfig(config));

    if (config.isFileDownload) {
      onRequestSuccess && onRequestSuccess(response);
    }
    else {
      if (response.status >= 200 && response.status < 400) {
        const data = await response.json();
        onRequestSuccess && onRequestSuccess(data);
      }
      else {
        throw await response.json();
      }
    }
  }
  catch (err) {
    onRequestFailure && onRequestFailure(err || { code: "NETWORK_ERROR" });
  }
  finally {
    onRequestFinish && onRequestFinish();
  }
};

const convertFromTranslationObject = (obj) => {
  let result = [];
  if (typeof obj === "string") obj = JSON.parse(obj);
  obj &&
    obj.languages &&
    obj.languages.forEach((lang) => {
      result.push({ code: lang, value: obj[lang] });
    });
  return result;
};

const convertToTranslationObject = (value) => {
  let result = {};
  if (typeof value === "string") value = JSON.parse(value);
  result.languages =
    (value && value.filter((v) => !!v.value).map((v) => v.code)) || [];
  result.languages.forEach((lang) => {
    result[lang] = value.find((v) => v.code === lang).value;
  });

  return result;
};

export {
  getUserFromLocalStorage,
  callApi,
  updateStatus,
  parseUrlQuery,
  convertToTranslationObject,
  convertFromTranslationObject,
};



// WEBPACK FOOTER //
// ./src/05-utils/commonUtils.js